import { ModuleProvider } from "./lib/context/module-context";
import { ThemeProvider } from "./lib/context/theme-context";

export const Providers = ({ children }) => {
  return (
    <ThemeProvider>
      <ModuleProvider>{children}</ModuleProvider>
    </ThemeProvider>
  );
};
